export default "__VITE_ASSET__b2510c77__"